import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.for-each.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.to-string.js';
import { __rest, __assign } from '../../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';
import { useRef, useState, useLayoutEffect } from 'react';
import useControlledState from '../useControlledState/index.js';
import { mergeRefs } from '../../utils/mergeRefs.js';
import { Collapse } from './Collapse.js';

var callAll = function callAll() {
  var fns = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    fns[_i] = arguments[_i];
  }
  return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    return fns.forEach(function (fn) {
      return fn && fn.apply(void 0, args);
    });
  };
};
function useCollapse(options) {
  if (options === void 0) {
    options = {};
  }
  var _isExpanded = options.isExpanded,
    _defaultExpanded = options.defaultExpanded,
    onExpandedChange = options.onExpandedChange,
    opts = __rest(options, ["isExpanded", "defaultExpanded", "onExpandedChange"]);
  var collapseEl = useRef(null);
  var _a = useControlledState(_defaultExpanded, {
      value: _isExpanded,
      onChange: onExpandedChange
    }),
    isExpanded = _a[0],
    setExpanded = _a[1];
  var resolvedOptions = __assign(__assign({}, opts), {
    getCollapseElement: function getCollapseElement() {
      return collapseEl.current;
    },
    defaultExpanded: isExpanded,
    onExpandedChange: setExpanded
  });
  var instance = useState(function () {
    return new Collapse(resolvedOptions);
  })[0];
  instance.setOptions(resolvedOptions);
  useLayoutEffect(function () {
    if (isExpanded) {
      instance.open();
    } else {
      instance.close();
    }
  }, [isExpanded, instance]);
  var initCollapseElement = function initCollapseElement(node) {
    if (collapseEl.current !== node) {
      collapseEl.current = node;
    }
  };
  return {
    getCollapseProps: function getCollapseProps(_a) {
      var _b, _c;
      if (_a === void 0) {
        _a = {};
      }
      var _d = _a.refKey,
        refKey = _d === void 0 ? 'ref' : _d,
        onTransitionEnd = _a.onTransitionEnd,
        rest = __rest(_a, ["refKey", "onTransitionEnd"]);
      var theirRef = rest[refKey];
      if (!instance) {
        return _b = {}, _b[refKey] = mergeRefs(theirRef, initCollapseElement), _b;
      }
      var _e = instance.getCollapse(),
        onTransitionEndHandler = _e.onTransitionEndHandler,
        props = __rest(_e, ["onTransitionEndHandler"]);
      return __assign(__assign(__assign({}, rest), props), (_c = {}, _c[refKey] = mergeRefs(theirRef, initCollapseElement), _c.onTransitionEnd = callAll(onTransitionEndHandler, onTransitionEnd), _c));
    },
    isExpanded: isExpanded,
    setExpanded: setExpanded
  };
}

export { useCollapse as default };
